<h2>Användare</h2>

<div class="container">

  <div class="toolbar">
    <div class="search-and-filters">
      <input type="search" [formControl]="searchInput" placeholder="Sök på Namn eller Alias" #input autocomplete="off"
        spellcheck="false" />

      <mat-radio-group class="filters" [(ngModel)]="roleFilter" (change)="applyRoleFilter()" name="roleFilter">
        
        <mat-radio-button color="primary" value="ALL">Alla</mat-radio-button>
        <mat-radio-button *ngFor="let role of roles" color="primary" [value]="role.name">
          {{ role.label }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <button class="button slim with-icon" (click)="openEditDialog()">
      <mat-icon>add</mat-icon>
      Ny användare
    </button>
  </div>

  <div class="users-content">
    <mat-paginator [length]="totalUsers" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" (page)="paginator($event)">
    </mat-paginator>

    <div class="empty-content" *ngIf="users.length === 0">
      <p>Kan inte hitta användare<span *ngIf="input.value">som matchar "{{ input.value }}"</span>.</p>
      <p>Kontrollera att du skrivit rätt namn eller anpassa valt rollfilter.</p>
    </div>

    <!-- Table -->
    <table mat-table [dataSource]="users" matSort matSortDirection="asc" (matSortChange)="sortColumns($event)"
      *ngIf="users.length > 0">

      <!-- Username Column -->
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="username">Namn</th>
        <td mat-cell *matCellDef="let user">{{ user.username }}</td>
      </ng-container>

      <!--  Alias Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Alias</th>
        <td mat-cell *matCellDef="let user">{{ user.name }}</td>
      </ng-container>

      <!-- Roles Column -->
      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef>Roller</th>
        <td mat-cell *matCellDef="let user">
          <span *ngFor="let role of user.roles; let last = last">
            {{ role.label }}<span *ngIf="!last">, </span>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['username','name','roles']"></tr>
      <tr mat-row *matRowDef="let user; columns: ['username','name','roles']" (click)="openEditDialog(user)">
      </tr>
    </table>

    <mat-paginator [length]="totalUsers" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" (page)="paginator($event)">
    </mat-paginator>

  </div>
</div>